import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { buildWorkspaceMemberFilterOptions } from "@components/pageHeader/filters/workspaceMemberFilter.lib";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

export const TemplateCreatedByFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: members = [] } = useCurrentWorkspaceMembers();

    const selectedIds = filters.invoiceTemplateCreatedByUserIds;
    const value = selectedIds ?? [];

    const options = useMemo(
        (): FilterMultiselectOption[] =>
            buildWorkspaceMemberFilterOptions({
                members,
                selectedUserIds: selectedIds,
            }),
        [members, selectedIds],
    );

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const ids = val.filter(
                        (v): v is number => typeof v === "number",
                    );
                    onChange({
                        invoiceTemplateCreatedByUserIds:
                            ids.length > 0 ? ids : undefined,
                    });
                }}
                name="invoiceTemplateCreatedByUserIds"
                onBlur={noop}
                searchable
            />
        </div>
    );
};
